<template>
    <div>
        <label :for="name" v-if="!admin">
            {{displayName}}
        </label>
        <input type="hidden" :name="name" :value="html">
        <input type="hidden" name="quill" :value="quillContents">
        <div class="pb-4">
            <div
                :name="name" 
                :id="name"
                ref="quill-input"
            ></div>
            <div class="invalid-feedback" v-if="errors">
                {{errors}}
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    export default {
      props: [
          'name',
          'displayName',
          'placeholder',
          'value',
          'editorBackground',
          'editorOverlay',
          'errors',
          'admin',
      ],
      data() {return {
          quill: null,
          quillContents: null,
          html: null,
      }},
      mounted() {
        this.quill = new Quill(this.$refs['quill-input'], {
            modules: {
                toolbar: [
                    [{ header: [2, 3, 4, 5, 6, false] }],
                    ['bold', 'italic', 'underline', {color: []}, { align: ['', 'right', 'center']}],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    ['link', 'image', 'iframe', 'html'],
                    ['clean'],
                ]
            },
            theme: 'snow'
        });

        this.quill.getModule('toolbar').addHandler('image', this.selectFile)
        this.quill.on('editor-change', _.debounce(this.editorChange, 200));

        this.quill.setContents(JSON.parse(this.value || '{}'))

        if (this.editorOverlay) {
            this.quill.container.children[0].style.cssText = `background: ${this.editorOverlay}; padding: 50px;`
        }
        if (this.editorBackground) {
            this.quill.container.style.cssText = `background: url(${this.editorBackground}) no-repeat center center;`
        }
      },
      watch: {
          editorBackground() {
                if (this.editorBackground) {
                    this.quill.container.style.cssText = `background: url(${this.editorBackground}) no-repeat center center;`
                    return
                }
                this.quill.container.style.cssText = `background: none;`

          },
          editorOverlay() {
              if (this.editorOverlay) {
                this.quill.container.children[0].style.cssText = `background: ${this.editorOverlay}; padding: 50px;`
              }
          },
      },
      methods: {
          selectFile(){
            const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.click();

                // Listen upload local image and save to server
                input.onchange = () => {
                    const file = input.files[0];
                    if (/^image\//.test(file.type)) {
                    this.saveToServer(file);
                    } else {
                    console.warn('You could only upload images.');
                    }
                };
          },
          saveToServer(file) {
                let that = this
                let formData = new FormData();
                formData.append('file', file)
                axios.post('/home/files/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress (progressEvent) {
                        let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        that.setUploadProgress(progress)
                    },                    
                })
                .then(response => {
                    this.insertToEditor(response.data.url);
                })
          },
          insertToEditor(url) {
                const range = this.quill.getSelection()
                this.quill.insertEmbed(range.index, 'image', url)
          },
          setUploadProgress(progress) {
          },
          editorChange (eventName, ...args) {
            if (eventName === 'text-change' || eventName === 'selection-change') {
                this.html = this.quill.root.innerHTML
                this.quillContents = JSON.stringify(this.quill.getContents())
                this.$emit('quillChanged', this.html, this.quillContents)
            }
          },

      },
    }
</script>

<style>
.ql-editor {
    max-height: 400px;
}
</style>